import { useFeatureFlag } from '@moda/portal-stanchions';

export const useInternationalDomesticShippingFeeOptimization = () =>
  useFeatureFlag('international-shipping-fee-optimization', [
    { default: 'controller' },
    { getFromTreatment: treatment => String(treatment) }
  ]);
